import React from 'react';
import {GoodsItem} from "./GoodsItem";
import SkeletonItem from './SkeletonItem';

interface Props {
    items: [];
    siteId:number;
    includeUserLoyaltyProgram: boolean;
    isEmptyResult?: boolean;
    isLoading?: boolean;
}


export class RenderGoods extends React.Component<Props, {}> {

    render() {
        // window.scrollTo( 0, 0 );
        let arData: any = this.props.items;
        let siteId:number = this.props.siteId;
        let includeUserLoyaltyProgram:boolean = this.props.includeUserLoyaltyProgram;
        let isEmptyResult:boolean = this.props.isEmptyResult || false;
        let isLoading:boolean = this.props.isLoading || false;
        let Width = window.innerWidth;
        let mobileWidth = 483;
        
        // Определяем количество карточек в ряду
        const cardsPerRow = Width < mobileWidth ? 1 : 4;

        // @ts-ignore
        return (
            <>
                <div className="goods-wrapper">
                    {isEmptyResult ? (
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            padding: '40px 0' ,
                            margin: 'auto'
                        }}>
                            <img 
                                src="/img/no-image.webp" 
                                alt="Товары не найдены" 
                                style={{ maxWidth: '100px'}}
                            />
                            товар отсутствует
                        </div>
                    ) : arData.length ? (
                        <>
                            {/* Рендерим реальные карточки товаров */}
                            {arData.map((item: any) => (
                                <GoodsItem key={'item-s'+item.id} item={item} siteId={siteId} includeUserLoyaltyProgram={includeUserLoyaltyProgram} />
                            ))}
                            
                            {/* Скелетоны НЕ показываем, если запросы отработали (есть данные) */}
                        </>
                    ) : isLoading ? (
                        <SkeletonItem count={cardsPerRow} />
                    ) : null}
                </div>
            </>
        );
    }
}